import { Injectable, inject } from '@angular/core';

import { Types } from '../../types.domain';
import { ValidateAccountConfirmationInput } from '../dtos/validate-account-confirmation.input';
import { ValidateAccountConfirmationServiceInterface } from '../interfaces/services/validate-account-confirmation.service.interface';

@Injectable()
export class ValidateAccountConfirmationService
  implements ValidateAccountConfirmationServiceInterface
{
  private readonly _authRepository = inject(Types.AuthRepository);

  async handle(input: ValidateAccountConfirmationInput) {
    return await this._authRepository.validateAccountConfirmation(input);
  }
}
